import * as Sentry from "@sentry/nuxt";

Sentry.init({
  // DSNを設定。環境がproductionの場合のみDSNを設定
  dsn:  useRuntimeConfig().public.sentry.environment === "production" ? useRuntimeConfig().public.sentry.dsn : "",
  // 環境を設定（例：local, develop, staging, production）
  environment: useRuntimeConfig().public.sentry.environment,
  // ブラウザトレースの統合を追加
  integrations: [Sentry.browserTracingIntegration()],
  // 無視するエラーを設定
  ignoreErrors: [
    // ランダムなプラグインや拡張機能によるエラー
    "top.GLOBALS",
    "originalCreateNotification",
    // ネットワークエラー
    "Network Error",
    "Failed to fetch",
    "Load failed",
    // その他のエラー
    "No error message",
    "NotSupportedError",
    "Unexpected token",
    "NotAllowedError",
  ],

  // トレースのサンプリング率を設定（0.1 = 10%）
  tracesSampleRate: 0.1,
});
